import { createAction } from "redux-actions";
import { IAction } from "reduxsauce";

import { mergeActionDefinitions } from "../../utils";
import { IClass, ICourse } from "../types/common";

export default mergeActionDefinitions("Classes", {
  deleteClass: ["classId"],
  handleDeleteClassFailure: ["error"],
  handleDeleteClassSuccess: ["classes"],
  mount: [],
  unmount: [],
});

export interface IClassIdAction extends IAction {
  classId: string;
}

export enum Action {
  ADD_NEW_CLASS = "ADD_NEW_CLASS",
  HANDLE_ADD_NEW_CLASS_FAILURE = "HANDLE_ADD_NEW_CLASS_FAILURE",
  HANDLE_ADD_NEW_CLASS_SUCCESS = "HANDLE_ADD_NEW_CLASS_SUCCESS",
  FETCH_ALL_COURSES = "FETCH_ALL_COURSES",
  HANDLE_FETCH_ALL_COURSES_FAILURE = "FETCH_ALL_COURSES",
  HANDLE_FETCH_ALL_COURSES_SUCCESS = "FETCH_ALL_COURSES",
  FETCH_ALL_CLASSES = "FETCH_ALL_CLASSES",
  HANDLE_FETCH_ALL_CLASSES_FAILURE = "HANDLE_FETCH_ALL_CLASSES_FAILURE",
  HANDLE_FETCH_ALL_CLASSES_SUCCESS = "HANDLE_FETCH_ALL_CLASSES_SUCCESS",
}

export const fetchAllCourses = createAction<void>(Action.FETCH_ALL_COURSES);
export const handleFetchAllCoursesFailure = createAction<{ message: string }>(Action.HANDLE_FETCH_ALL_COURSES_FAILURE);
export const handleFetchAllCoursesSuccess = createAction<ICourse[]>(Action.HANDLE_FETCH_ALL_COURSES_SUCCESS);
export const addNewClass = createAction<void>(Action.ADD_NEW_CLASS);
export const handleAddNewClassFailure = createAction<{ message: string }>(Action.HANDLE_ADD_NEW_CLASS_FAILURE);
export const handleAddNewClassSuccess = createAction<void>(Action.HANDLE_ADD_NEW_CLASS_SUCCESS);
export const fetchAllClasses = createAction<void>(Action.FETCH_ALL_CLASSES);
export const handleFetchAllClassesFailure = createAction<{ message: string }>(Action.HANDLE_FETCH_ALL_CLASSES_FAILURE);
export const handleFetchAllClassesSuccess = createAction<IClass[]>(Action.HANDLE_FETCH_ALL_CLASSES_SUCCESS);
